import React, { type FC } from 'react';
import Button from '@atlaskit/button/standard-button';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import { useIntl } from '@atlassian/jira-intl';
import authenticateImage from '../../assets/authenticate-confluence.svg';
import MessageCallToAction from '../../message-call-to-action';
import messages from './messages';

export type Props = {
	onAuthenticate: () => Promise<void>;
};

export const AuthenticationPanel: FC<Props> = ({ onAuthenticate }) => {
	const { formatMessage } = useIntl();

	const onActionClick = () => {
		onAuthenticate();
	};

	return (
		<MessageCallToAction
			imageUrl={authenticateImage}
			header=""
			description={formatMessage(messages.pageDescription)}
			primaryAction={
				<Button
					iconBefore={<LockFilledIcon label="authenticate" />}
					appearance="primary"
					onClick={onActionClick}
				>
					{formatMessage(messages.primaryAction)}
				</Button>
			}
		/>
	);
};

export default AuthenticationPanel;
